module.exports = __webpack_public_path__ + "img/go-left.8b65817d.svg";